export default "__VITE_ASSET__Bufkz2QY__"